import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  resetPageScrollToTop,
  shouldSkipScrollResetForHash,
} from "../../utils/resetPageScrollToTop";
import {
  getPublicPageScrollResetKey,
  isPublicPageScrollResetPath,
} from "../../utils/publicPageScrollReset";
import {
  hasVacationPackagesScrollRestorePending,
  VP_LOCATION_RESTORE,
} from "../../utils/vacationPackagesResultsReturn";

/**
 * Client-side route changes keep window / .client-pages / .client-component
 * scroll offset. Reset the real page scroller on important public pages.
 */
export default function PublicPageScrollReset() {
  const location = useLocation();
  const resetKey = getPublicPageScrollResetKey(location);
  const matchesPublicPage = isPublicPageScrollResetPath(location.pathname);

  useEffect(() => {
    if (typeof window === "undefined" || !window.history || !("scrollRestoration" in window.history)) {
      return undefined;
    }
    if (!matchesPublicPage) return undefined;
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = previous || "auto";
    };
  }, [matchesPublicPage]);

  useLayoutEffect(() => {
    if (!matchesPublicPage) return;
    if (shouldSkipScrollResetForHash(location.hash)) return;
    if (hasVacationPackagesScrollRestorePending() || location.state?.[VP_LOCATION_RESTORE]) {
      return;
    }
    resetPageScrollToTop({ includeAgentShell: false });
  }, [resetKey, matchesPublicPage, location.hash, location.state]);

  return null;
}
